import _objectWithoutProperties from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var _excluded = ["action", "angle", "origin", "radius"];

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { _ as t } from "../tslib.es6.js";
import { T as e } from "../index.js";
import * as i from "@arcgis/core/geometry/geometryEngine";
import * as s from "@arcgis/core/geometry/support/geodesicUtils";
import * as n from "@arcgis/core/geometry/support/webMercatorUtils";
import h from "@arcgis/core/Graphic";
import a from "@arcgis/core/geometry/Circle";
import o from "@arcgis/core/geometry/Polygon";
import r from "@arcgis/core/geometry/Polyline";
import l from "@arcgis/core/geometry/Point";
import { c as d } from "../enums.js";
import { U as p, G as g, b as c } from "./utils.js";
import { S as m, J as u } from "../symbols.js";
import { A as y, L as P } from "../utils/auto-pan.js";
import { H as S } from "../history-manager.js";

var f, _;

var _getAngleForSegment = function _getAngleForSegment(t, e, i) {
  var h = Math.asin(null == i ? function (t, e) {
    var i = g.createPolyline([t, e]),
        h = s.geodesicLengths([n.webMercatorToGeographic(i)], "feet")[0],
        a = new l({
      x: e.x,
      y: t.y,
      spatialReference: t.spatialReference
    });
    return s.geodesicLengths([n.webMercatorToGeographic(g.createPolyline([a, e]))], "feet")[0] / h;
  }(t, e) : i);
  return e.y > t.y && e.x <= t.x ? h = -h + Math.PI : e.y <= t.y && e.x < t.x ? h += Math.PI : e.y < t.y && e.x >= t.x && (h = -h + 2 * Math.PI), h;
};

var GeometryCreator = /*#__PURE__*/function () {
  function GeometryCreator(t) {
    var _this = this;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, GeometryCreator);

    if (f.add(this), this.finishedDrawing = !1, this.map = t, this.drawLayer = e.drawLayer || t.graphics[0], this.geometryType = e.geometryType, this.symbol = e.symbol || function (t) {
      var e = [0, 255, 0];

      switch (t) {
        case d.POINT:
          return m.fromJSON(u.createSimpleMarkerSymbolJSON(e, 10));

        case d.CIRCLE:
        case d.POLYGON:
          return m.fromJSON(u.createSimpleFillSymbolJSON([0, 0, 0, .4], e, 2));

        case d.POLYLINE:
          return m.fromJSON(u.createSimpleLineSymbolJSON(e, 2));

        default:
          return null;
      }
    }(this.geometryType), this.invalidSymbol = e.invalidSymbol || function (t) {
      var e = [255, 0, 0];

      switch (t) {
        case d.POINT:
          return m.fromJSON(u.createSimpleMarkerSymbolJSON(e, 10));

        case d.CIRCLE:
        case d.POLYGON:
          return m.fromJSON(u.createSimpleFillSymbolJSON([0, 0, 0, .4], e, 2, "esriSLSDash"));

        case d.POLYLINE:
          return m.fromJSON(u.createSimpleLineSymbolJSON(e, 2));

        default:
          return null;
      }
    }(this.geometryType), this.onDraw = e.onDraw, this.onSegmentUpdated = "function" == typeof e.onSegmentUpdated && e.onSegmentUpdated, this.autoPan = new y(this.map, e.autoPanInsets), this.persistGraphics = e.persistGraphics, this.nudgeOptions = _objectSpread({
      enabled: !1,
      segment: !1
    }, e.nudgeOptions), this.onNbrGraphicsChanged = e.onNbrGraphicsChanged, this.outlineSymbol = null, "simple-fill" === this.symbol.type) {
      var _t = this.symbol,
          _e = this.invalidSymbol;
      this.outlineSymbol = _t.outline.clone(), this.invalidOutlineSymbol = _e.outline.clone();
      var _i = {
        style: "none"
      };
      _t.outline = _i, _e.outline = _i;
    }

    this.listeners = new P(), this.history = new S(), this.history.on("state-change", function (t) {
      return _this._setPoints(t);
    }), this.startedPoly = !1, this.isValueNudged = !1, this.nudgeAngle = 0, this.nudgedSegmentLength = 0, this.setCurrentLengthUnit(p.FEET), this.map.on("double-click", function (t) {
      (_this._isActive || _this.finishedDrawing) && (_this.finishedDrawing = !1, t.stopPropagation());
    }), this.listeners.add(this.map.on("key-down", this.stopPropagation.bind(this)));
  }

  _createClass(GeometryCreator, [{
    key: "stopPropagation",
    value: function stopPropagation(t) {
      this._isActive && t.stopPropagation();
    }
  }, {
    key: "_addMouseLocation",
    value: function _addMouseLocation(t) {
      var i = this.map.toMap(t);
      if (this.geometryType === d.POINT) return this._updateGraphics([i], !0), void this._resetDrawing();
      this.startedPoly = !0;
      var s = Math.abs(this.clickX - t.native.screenX) <= e.clickTolerance && Math.abs(this.clickY - t.native.screenY) <= e.clickTolerance;

      if (s ? (this.clickX = void 0, this.clickY = void 0) : (this.clickX = t.native.screenX, this.clickY = t.native.screenY), this.geometryType === d.POLYGON) {
        var _t2 = this.isSegmentNudged ? this.points : [].concat(_toConsumableArray(this.points), [i]);

        if (this.points.length > 2 && !this._isValid(this._getPolygon(_t2), s)) return void this._updateGraphics(_t2, !1, !0);
      }

      if (s) {
        if (this.points && this.points.length > 1) if (this.geometryType !== d.POLYGON) this._updateGraphics(this.points, !0);else {
          if (!(this.points.length > 2)) return;

          this._updateGraphics([].concat(_toConsumableArray(this.points), [this.points[0]]), !0);
        }
        !this.finishedDrawing && this._resetDrawing();
      } else !0 === t.native.ctrlKey && this.points.length > 0 ? (i = this.isSegmentNudged ? this.points[this.points.length - 1] : this._snapPoint(this.points[this.points.length - (this.isSegmentNudged ? 2 : 1)], i, this.points[this.points.length - (this.isSegmentNudged ? 3 : 2)], t.native.altKey), this.isSegmentNudged ? this._replaceLastPoint(i) : this._addPoint(i)) : this.isSegmentNudged || this._addPoint(i), this.isSegmentNudged = !1;
    }
  }, {
    key: "_addPoint",
    value: function _addPoint(t) {
      this.points.push(t), this.history.add(JSON.parse(JSON.stringify(this.points)));
    }
  }, {
    key: "_replaceLastPoint",
    value: function _replaceLastPoint(t) {
      this.points.pop(), this._addPoint(t);
    }
  }, {
    key: "_calculatePoint",
    value: function _calculatePoint(t, e, s) {
      var n = 3 * s,
          h = Math.sin(e) * n,
          o = Math.cos(e) * n,
          r = new l({
        x: t.x + o * this.currentLengthUnitToMetersConv,
        y: t.y + h * this.currentLengthUnitToMetersConv,
        spatialReference: t.spatialReference
      }),
          d = new a({
        center: t,
        geodesic: !0,
        numberOfPoints: 1e4,
        radius: s,
        radiusUnit: this.currentLengthUnit
      }),
          p = g.createPolyline([t, r]),
          c = i.intersect(d, p),
          _c$paths$0$ = _slicedToArray(c.paths[0][1], 2),
          m = _c$paths$0$[0],
          u = _c$paths$0$[1];

      return new l({
        x: m,
        y: u,
        spatialReference: t.spatialReference
      });
    }
  }, {
    key: "_createMouseListeners",
    value: function _createMouseListeners() {
      var _this2 = this;

      this.listeners.removeAll(), this.listeners.add(this.map.on("drag", this.stopPropagation.bind(this))), this.listeners.add(this.map.on("click", this.stopPropagation.bind(this))), this.geometryType === d.CIRCLE ? (this.listeners.add(this.map.on("key-down", this.stopPropagation.bind(this))), this.listeners.add(this.map.on("pointer-down", function (t) {
        var e = _this2.map.toMap(t);

        _this2.circleCenter = e, _this2.isValueNudged = !1;
      })), this.listeners.add(this.map.on("drag", function (s) {
        var n = "end" === s.action;

        if (_this2.isValueNudged) {
          if (n) {
            var _t3 = _this2.graphic.geometry;

            _this2._updateGraphics(_this2._getPointsFromPoly(_t3), !0, !1, _t3);
          } else if (Math.abs(_this2.lastDragEvent.x - s.x) <= e.clickTolerance && Math.abs(_this2.lastDragEvent.y - s.y) <= e.clickTolerance) return;
        } else {
          var _e2 = _this2.map.toMap(s);

          _this2.lastDragEvent = s;

          var _h = g.createPolyline([_this2.circleCenter, _e2]),
              _o = new a({
            center: _this2.circleCenter,
            geodesic: !0,
            radius: i.geodesicLength(_h, "feet"),
            radiusUnit: "feet"
          });

          _this2._updateGraphics(_this2._getPointsFromPoly(_o), n, !1, _o), t(_this2, f, "m", _).call(_this2, s, _o, _o.radius);
        }

        _this2.isValueNudged = !1;
      })), this.listeners.add(this.map.on("key-up", function (e) {
        var i = ["Add", "+", "=", "Up", "ArrowUp"].includes(e.key),
            s = ["Subtract", "-", "_", "Down", "ArrowDown"].includes(e.key);

        if (i || s) {
          var _s = _this2.graphic.geometry;

          var _n = Math.round(_s.radius),
              _h2 = i ? 1 : -1;

          e.native.shiftKey && (_this2.isValueNudged && _n % 5 == 0 ? _h2 = i ? 5 : -5 : (_n = 5 * (i ? Math.ceil(_n / 5) : Math.floor(_n / 5)), _h2 = 0));

          var _o2 = new a({
            center: _this2.circleCenter,
            geodesic: !0,
            radius: _n + _h2,
            radiusUnit: "feet"
          });

          _this2._updateGraphics(_this2._getPointsFromPoly(_o2), !1, !1, _o2), t(_this2, f, "m", _).call(_this2, e, _o2, _o2.radius), _this2.isValueNudged = !0;
        }
      }))) : (this.geometryType !== d.POINT ? this.listeners.add(this.map.on("pointer-down", this._addMouseLocation.bind(this))) : this.listeners.add(this.map.on("pointer-up", this._addMouseLocation.bind(this))), this.geometryType !== d.POLYLINE && this.geometryType !== d.POLYGON || !this.nudgeOptions.enabled || (this.listeners.add(this.map.on("key-up", this._nudge.bind(this))), this.listeners.add(this.map.on("key-down", this._disableBrowserZoom.bind(this)))), this.listeners.add(this.map.on("key-down", function (t) {
        return "Control" === t.key && _this2._segmentUpdated(t);
      })), this.listeners.add(this.map.on("key-up", function (t) {
        return "Control" === t.key && _this2._segmentUpdated(t);
      })), this.listeners.add(this.map.on("pointer-move", this._updateLastPoint.bind(this))), this.listeners.add(this.map.on("pointer-enter", function () {
        window.focus(), _this2.map.focus();
      })));
    }
  }, {
    key: "_disableBrowserZoom",
    value: function _disableBrowserZoom(t) {
      !0 === t.native.ctrlKey && ["Add", "+", "=", "Up", "ArrowUp", "Subtract", "-", "_", "Down", "ArrowDown"].includes(t.key) && t.preventDefault(), this._isActive && t.stopPropagation();
    }
  }, {
    key: "_getPointsFromPoly",
    value: function _getPointsFromPoly(t) {
      var _this3 = this;

      return t.rings[0].map(function (t) {
        return new l({
          x: t[0],
          y: t[1],
          spatialReference: _this3.map.spatialReference
        });
      });
    }
  }, {
    key: "_getPolygon",
    value: function _getPolygon(t) {
      return new o({
        rings: [t.map(function (t) {
          return [t.x, t.y];
        })],
        spatialReference: {
          wkid: this.map.spatialReference.wkid
        }
      });
    }
  }, {
    key: "_getPolyline",
    value: function _getPolyline(t) {
      return new r({
        paths: [t.map(function (t) {
          return [t.x, t.y];
        })],
        spatialReference: {
          wkid: this.map.spatialReference.wkid
        }
      });
    }
  }, {
    key: "_isValid",
    value: function _isValid(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (this.geometryType === d.POLYGON) {
        var _s2 = t ? i.simplify(t) : null;

        return _s2 && (1 === _s2.rings.length || !e && !c.lastEdgeSelfIntersects(t));
      }

      return !0;
    }
  }, {
    key: "_nudge",
    value: function _nudge(t) {
      if (this.map.scale > e.minVertexNudgeScale) return;
      var i = ["Add", "+", "=", "Up", "ArrowUp"].includes(t.key),
          s = ["Subtract", "-", "_", "Down", "ArrowDown"].includes(t.key);
      if (!i && !s) return;
      var n = this.graphic && this.graphic.geometry ? this.graphic.geometry : {};

      if ((n.rings || n.paths || []).length > 0) {
        var _e3 = t.native.shiftKey ? 5 : 1,
            _s3 = i ? _e3 : -1 * _e3;

        this._nudgeSegment(_s3, t), this._segmentUpdated(t, this.nudgedSegmentLength);
      }
    }
  }, {
    key: "_nudgeSegment",
    value: function _nudgeSegment(t, e) {
      var i = this.isSegmentNudged ? this.points[this.points.length - 1] : !0 === e.native.ctrlKey ? this._snapPoint(this.points[this.points.length - (this.isSegmentNudged ? 2 : 1)], this.lastMapPoint, this.points[this.points.length - (this.isSegmentNudged ? 3 : 2)], e.native.altKey) : this.lastMapPoint;
      this.isSegmentNudged || (this.nudgeStartPt = this.points[this.points.length - 1], this.nudgeAngle = _getAngleForSegment(this.nudgeStartPt, i));
      var h = g.createPolyline([this.nudgeStartPt, i]),
          a = s.geodesicLengths([n.webMercatorToGeographic(h)], this.currentLengthUnit)[0],
          o = s.geodesicLengths([n.webMercatorToGeographic(this.graphic.geometry)], this.currentLengthUnit)[0];
      var r;
      if (this.isSegmentNudged) r = a + t;else if (!1 === this.nudgeOptions.segment) {
        r = (t > 0 ? Math.ceil(o / t) : Math.floor(o / Math.abs(t))) * Math.abs(t) - (o - a);
      } else r = (t > 0 ? Math.ceil(a / t) : Math.floor(a / Math.abs(t))) * Math.abs(t);
      if (r <= 0) return;
      this.nudgedSegmentLength = r;

      var l = this._calculatePoint(this.nudgeStartPt, this.nudgeAngle, r);

      this.isSegmentNudged ? this._replaceLastPoint(l) : this._addPoint(l), this._updateGraphics(this.points), this.isSegmentNudged = !0;
    }
  }, {
    key: "_resetDrawing",
    value: function _resetDrawing() {
      this.startedPoly = !1, this.isSegmentNudged = !1, this.points = [], this.persistGraphics || (this.drawLayer.remove(this.graphic), this.drawLayer.remove(this.outlineGraphic)), this.graphic = null, this.outlineGraphic = null, this.history.reset(), this.history.add([]);
    }
  }, {
    key: "_segmentUpdated",
    value: function _segmentUpdated(t, e) {
      if (this.onSegmentUpdated && this.points && this.points.length > 0 && (this.lastMapPoint || this.isSegmentNudged)) {
        var _i2 = t,
            _s4 = this.points[this.points.length - (this.isSegmentNudged ? 2 : 1)],
            _n2 = this.isSegmentNudged ? this.points[this.points.length - 1] : this.lastMapPoint;

        _i2.segment = {
          start: _s4,
          end: _n2
        }, _i2.graphic = this.graphic, null != e && (_i2.length = e), "function" == typeof this.onSegmentUpdated && this.onSegmentUpdated(_i2);
      }
    }
  }, {
    key: "_setPoints",
    value: function _setPoints(t) {
      this.points = JSON.parse(JSON.stringify(t));
      var e = this.lastMapPoint ? [].concat(_toConsumableArray(this.points), [this.lastMapPoint]) : this.points;
      e.length > 0 && this._updateGraphics(e);
    }
  }, {
    key: "_snapPoint",
    value: function _snapPoint(t, e, i) {
      var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      if (this.isSegmentNudged) this.snappedSegmentLength = this.nudgedSegmentLength;else {
        var _i3 = g.createPolyline([t, e]);

        this.snappedSegmentLength = s.geodesicLengths([n.webMercatorToGeographic(_i3)], this.currentLengthUnit)[0];
      }
      var a = 180 * _getAngleForSegment(t, e) / Math.PI,
          o = null != i ? 180 * _getAngleForSegment(t, i) / Math.PI : 0,
          r = Math.abs(a - o),
          l = r >= 180 ? 360 - r : r,
          d = r === l;
      var p, c, m, u;
      if (null != i) {
        if (p = 75, c = 105, m = l >= p && l <= c, h) {
          var _t4 = 15 * Math.round(r / 15);

          u = o > a ? o - _t4 : o + _t4;
        } else {
          var _t5 = o + (o < a && d || o > a && !d ? 90 : -90);

          u = _t5 < 0 ? 360 - Math.abs(o - 90) : _t5;
        }
      } else {
        var _t6 = 90 * Math.round(a / 90);

        p = _t6 - 15, c = _t6 + 15, m = a >= p && a <= c, u = h ? 15 * Math.round(a / 15) : _t6;
      }
      return this.isSegmentNudged && (u = m ? u : a), this.isSegmentNudged || h || (!h || null == i) && m ? this._calculatePoint(t, u * Math.PI / 180, this.snappedSegmentLength) : e;
    }
  }, {
    key: "_updateGraphics",
    value: function _updateGraphics(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var o;

      switch (this.drawLayer.remove(this.graphic), this.finishedDrawing = e, this.outlineGraphic && this.drawLayer.remove(this.outlineGraphic), this.geometryType) {
        case d.POINT:
          o = t[0], this.graphic = e ? new h({
            attributes: {},
            geometry: o,
            symbol: s ? this.invalidSymbol : this.symbol
          }) : null;
          break;

        case d.CIRCLE:
        case d.POLYGON:
          {
            o = n || i.simplify(this._getPolygon(t));

            var _e4 = !s && (t.length < 3 || this._isValid(o));

            this.graphic = new h({
              attributes: {},
              geometry: o,
              symbol: _e4 ? this.symbol : this.invalidSymbol
            }), this.outlineSymbol && (this.outlineGraphic = new h({
              attributes: {},
              geometry: this._getPolyline(t),
              symbol: _e4 ? this.outlineSymbol : this.invalidOutlineSymbol
            }));
            break;
          }

        case d.POLYLINE:
          o = this._getPolyline(t), this.graphic = new h({
            attributes: {},
            geometry: o,
            symbol: s ? this.invalidSymbol : this.symbol
          });
          break;

        default:
          this.graphic = null;
      }

      this.graphic && (this.drawLayer.add(this.graphic), this.outlineGraphic && this.drawLayer.add(this.outlineGraphic)), e && this.onNbrGraphicsChanged && this.onNbrGraphicsChanged({
        count: 1
      }), this.onDraw && this.onDraw({
        finished: e,
        geometry: o,
        points: t,
        lastIsSpeculative: a
      });
    }
  }, {
    key: "_updateLastPoint",
    value: function _updateLastPoint(t) {
      var e = this.map.toMap(t);

      if (this.lastMapPoint = e, this.geometryType !== d.POINT) {
        if (this.startedPoly) {
          var _i4;

          if (this.isSegmentNudged && (this.nudgeAngle = _getAngleForSegment(this.nudgeStartPt, e)), !0 === t.native.ctrlKey && this.points.length > 0) {
            var _s5 = this.points[this.points.length - (this.isSegmentNudged ? 2 : 1)],
                _n3 = this.points[this.points.length - (this.isSegmentNudged && this.points.length > 2 ? 3 : 2)],
                _h3 = this._snapPoint(_s5, e, _s5 !== _n3 ? _n3 : null, t.native.altKey);

            this.isSegmentNudged ? (_i4 = this.nudgedSegmentLength, this._replaceLastPoint(_h3), this._updateGraphics(this.points)) : (_i4 = this.snappedSegmentLength, this._updateGraphics([].concat(_toConsumableArray(this.points), [_h3]), !1, !1, null, !0)), this.lastMapPoint = _h3;
          } else if (this.isSegmentNudged) {
            var _t7 = this._calculatePoint(this.nudgeStartPt, this.nudgeAngle, this.nudgedSegmentLength);

            _i4 = this.nudgedSegmentLength, this._replaceLastPoint(_t7), this._updateGraphics(this.points);
          } else this._updateGraphics([].concat(_toConsumableArray(this.points), [e]), !1, !1, null, !0);

          this._segmentUpdated(t, _i4);
        }
      } else this._updateGraphics([e]);
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this4 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this._isActive = !0, this.lastMapPoint = null, this._resetDrawing(), t && t.length && (t.forEach(function (t) {
        _this4._addPoint(t);
      }), this._updateGraphics(this.points), this.startedPoly = !0), this._createMouseListeners(), this.autoPan.activate(), this.map.map.reorder(this.drawLayer, this.map.map.layers.length - 1);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _this5 = this;

      return this._isActive ? (this._isActive = !1, new Promise(function (t) {
        setTimeout(function () {
          _this5.autoPan.deactivate().then(function () {
            t();
          });
        }), _this5.listeners.removeAll(), _this5.startedPoly && (_this5.drawLayer.remove(_this5.graphic), _this5.drawLayer.remove(_this5.outlineGraphic)), _this5._resetDrawing();
      })) : Promise.resolve();
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return Boolean(this._isActive);
    }
  }, {
    key: "measureInProgress",
    value: function measureInProgress() {
      return Boolean(this.startedPoly);
    }
  }, {
    key: "setInsets",
    value: function setInsets(t) {
      this.autoPan.setInsets(t);
    }
  }, {
    key: "setCurrentLengthUnit",
    value: function setCurrentLengthUnit(t) {
      this.currentLengthUnit = t, this.currentLengthUnitToMetersConv = c.esriUnitToMetersConversion(t);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._resetDrawing();
    }
  }]);

  return GeometryCreator;
}();

f = new WeakSet(), _ = function _(t, e, i) {
  if (this.onSegmentUpdated && "function" == typeof this.onSegmentUpdated) {
    var _s6 = e.center,
        _n4 = new l({
      x: _s6.x,
      y: _s6.y - i,
      spatialReference: e.spatialReference.clone()
    }),
        _h4 = t.action,
        _a = t.angle,
        _o3 = t.origin,
        _r = t.radius,
        _d = _objectWithoutProperties(t, _excluded),
        _p = _objectSpread(_objectSpread({}, _d), {}, {
      graphic: this.graphic,
      length: e.radius,
      native: t.native,
      pointerId: t.native.pointerId,
      pointerType: t.native.pointerType,
      segment: {
        start: _s6,
        end: _n4
      },
      type: "pointer-move"
    });

    this.onSegmentUpdated(_p);
  }
};
export { GeometryCreator as G };